import { CountUp }      from 'countup.js'


//This counts up numbers
function countupNumbers() {
  const infoNumberElement = $(".number__digit");
  infoNumberElement.css("opacity","1");
  //To add % after digit
  var options = {
    useEasing : true,
    separator: ' ',
  };

  infoNumberElement.each(function () {
      var dataAttributes = this.dataset;
      const numAnim = new CountUp(this, dataAttributes.number, options);
      if (!numAnim.error) {
          numAnim.start();
      } else {
          console.error(numAnim.error);
      }
  });
}
export default countupNumbers
